import src from "./brands-desktop.png";
export default { src: src, aspect: 38.724137931034484, width: 2246, height: 58 };